import isEmpty from 'lodash/isEmpty';
import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';

function SectionOne({ data }: any) {
  if (isEmpty(data)) return null;
  const allData = {
    item1: convertDatasets(data, 'image-header', true),
    item2: convertDatasets(data, 'topic-1', true),
    item3: convertDatasets(data, 'topic-2', true),
    item4: convertDatasets(data, 'topic-3', true),
    item5: convertDatasets(data, 'topic-4', true),
    item6: convertDatasets(data, 'topic-5', true),
    item7: convertDatasets(data, 'path', true),
    item8: convertDatasets(data, 'bg', true),
    item9: convertDatasets(data, 'topic-6', true),
    item10: convertDatasets(data, 'partner-text', true),
    item11: convertDatasets(data, 'link-1', true),
    item12: convertDatasets(data, 'link-2', true),
    item13: convertDatasets(data, 'link-3', true),
    item14: convertDatasets(data, 'link-4', true),
    item15: convertDatasets(data, 'link-5', true)
  };
  const dataImage = data.filter((item: any) => item.key.startsWith('partner-image'));
  const datatext = data.filter((item: any) => item.key.startsWith('text'));
  const link = data.filter((item: any) => item.key.startsWith('link'));
  return (
    <SectionWrapper className='section-1' bg={allData.item8}>
      <div className='container'>
        {!isEmpty(allData.item1) && (
          <div className='image-header'>
            <img src={allData?.item1} title={'image-header'} />
          </div>
        )}
        <div className='content'>
          <h3>{allData.item2}</h3>
          <h3>{allData.item3}</h3>
          <h3>{allData.item4}</h3>
          <h3>{allData.item5}</h3>
          <div className='footer-text'>
            <h3>{allData.item6}</h3>
            <h3>{allData.item9}</h3>
          </div>

          {!isEmpty(allData.item7) && (
            <a href={allData.item7} target='_blank' className='button-text'>
              ลงทะเบียน
            </a>
          )}
          <div className='section-partners'>
            <div className='title-text'>{allData.item10}</div>
            <div className='partner-list'>
              {dataImage.map((item: any, index: number) => (
                <a href={`${link?.[index]?.value}`} className='flex' target='_blank'>
                  <img className='circle-image' src={item.value} key={index} />
                  {!isEmpty(datatext[index]) && <span>{datatext[index].value}</span>}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
interface Props {
  bg: string;
}
const SectionWrapper = styled.div<Props>`
  background-image: url(${p => p.bg});
  background-repeat: no-repeat;
  background-size: cover;
  .image-header {
    display: flex;
    justify-content: center;
    img {
      width: 40%;
      height: auto;
    }
  }
  .content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    h3 {
      color: #3d3d3d;
      font-weight: 600;
      font-size: 32px;
      @media (max-width: 1024px) {
        font-size: 24px;
      }
      @media (max-width: 690px) {
        font-size: 20px;
      }
      @media (max-width: 500px) {
        font-size: 16px;
      }
    }
    .footer-text {
      text-align: center;
      margin-top: 32px;
      h3 {
        font-size: 22px;
        @media (max-width: 500px) {
          font-size: 12px;
        }
      }
    }
    .button-text {
      background-color: #6b64a0;
      padding: 12px 24px;
      border-radius: 40px;
      margin: 20px 0;
      color: #fff;
      font-weight: 500;
      font-size: 36px;
      @media (max-width: 1024px) {
        font-size: 28px;
      }
      @media (max-width: 690px) {
        font-size: 20px;
      }
      @media (max-width: 500px) {
        font-size: 16px;
        padding: 10px 20px;
      }
    }
  }
  .section-partners {
    position: relative;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 30px;
    padding-top: 100px;
    @media (max-width: 767px) {
      padding-top: 40px;
    }
    .title-text {
      color: #fff;
      font-size: 28px;
      font-weight: 400;
      text-shadow: 0px 1px, 1px 0px, 1px 1px;
      letter-spacing: 2px;
      cursor: context-menu;
      @media (max-width: 767px) {
        font-size: 18px;
      }
    }
    .partner-list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 40px;
      grid-row-gap: 10px;
    }
    .flex {
      width: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 0 5px;
      gap: 12px;
      span {
        font-size: 18px;
        text-transform: uppercase;
        color: rgb(61, 61, 61);
        font-weight: 400;
        text-align: center;
        letter-spacing: 1px;
        text-shadow: 0px 1px, 1px 0px, 1px 1px;
        @media (max-width: 768px) {
          font-size: 10px;
        }
      }
    }
    .circle-image {
      border-radius: 50%;
      width: 50%;

      @media (max-width: 767px) {
        width: 80%;
      }
    }
  }
`;
export default SectionOne;
